import { render, staticRenderFns } from "./MapBackground.vue?vue&type=template&id=2cc108f2&scoped=true&lang=pug&"
import script from "./MapBackground.vue?vue&type=script&lang=js&"
export * from "./MapBackground.vue?vue&type=script&lang=js&"
import style0 from "./MapBackground.vue?vue&type=style&index=0&id=2cc108f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc108f2",
  null
  
)

component.options.__file = "MapBackground.vue"
export default component.exports